import { render } from "./RobotsTxt.vue?vue&type=template&id=dd34cf44"
import script from "../js/robots-txt.js?vue&type=script&lang=js"
export * from "../js/robots-txt.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__